import { useEffect } from "react";
import { useLocation } from "react-router";
import { getSavedInstanceId } from "../utils/authService";

export function InstanceIdUrlEnforcer() {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (!params.get("instanceid")) {
      const savedId = getSavedInstanceId();
      if (savedId) {
        params.set("instanceid", savedId);
        const newUrl = location.pathname + "?" + params.toString() + location.hash;
        window.history.replaceState({}, "", newUrl);
      }
    }
  }, [location.pathname, location.search]);

  return null;
}
